const ROUTES = {
  BASE: "",
  LOGIN: "/login",
  FORGET_PASSWORD: "/forget-password",
  SIGN_UP_VENDOR: "/signup/vendor",
  SIGN_UP_ADMIN: "/signup/admin",
};
const CROSSPAY_ROUTES = {
  DASHBOARD: `${ROUTES.BASE}/`,
  CHECK_BALANCE: `${ROUTES.BASE}/check-balance`,
  PRODUCT: `${ROUTES.BASE}/products`,
  PRODUCT_ITEM_VIEW: `${ROUTES.BASE}/products/product-items`,
  BATCH_DETAILS_VIEW: `${ROUTES.BASE}/products/batch-details`,
  ADD_PRODUCT: `${ROUTES.BASE}/products/add-product`,
  EDIT_PRODUCT: `${ROUTES.BASE}/products/edit-product`,
  MERCHANTS: `${ROUTES.BASE}/merchants`,
  INVOICING: `${ROUTES.BASE}/invoicing`,
  INVOICE_DETAILS: `${ROUTES.BASE}/invoice/details`,
  REPORTS: `${ROUTES.BASE}/reports`,
  REPORT_SALES: `${ROUTES.BASE}/reports/sales`,
  REPORT_REDEMPTION: `${ROUTES.BASE}/reports/redemption`,
  REPORT_PRODUCT_INVENTORY: `${ROUTES.BASE}/reports/product-inventory`,
  REPORT_INVOICING: `${ROUTES.BASE}/reports/invoicing`,
  REPORT_CUSTOMER_BEHAVIOUR: `${ROUTES.BASE}/reports/customer-behaviour`,
  REPORT_TRANSACTION: `${ROUTES.BASE}/reports/transaction`,
  ADD_CLIENT: `${ROUTES.BASE}/clients/add-client`,
  CLIENT_VIEW: `${ROUTES.BASE}/clients`,
  CLIENT_DETAILS: `${ROUTES.BASE}/client/details`,
  REDEMPTION_CHANNEL: `${ROUTES.BASE}/branches`,
  POINT_OF_SALE: `${ROUTES.BASE}/point-of-sale`,
  ADD_POINT_OF_SALE: `${ROUTES.BASE}/point-of-sale/add`,
  EDIT_CLIENT: `${ROUTES.BASE}/clients/edit-client`,
  ADD_BRANCH: `${ROUTES.BASE}/branch/add-branch`,
  EDIT_BRANCH: `${ROUTES.BASE}/branch/edit-branch`,
  USER_VIEW: `${ROUTES.BASE}/client-account`,
  ADD_USER: `${ROUTES.BASE}/client-account/add-client-account`,
  EDIT_USER: `${ROUTES.BASE}/client-account/edit-client-account`,
  SETTINGS: `${ROUTES.BASE}/settings`,
  CHANGE_PASSWORD: `${ROUTES.BASE}/change-password`,
  CARD_OPERATIONS: `${ROUTES.BASE}/card-operations`,
  PRODUCT_DETAILS: `${ROUTES.BASE}/products/details`,
};

const VENDOR_ROUTES = {};
export { ROUTES, CROSSPAY_ROUTES, VENDOR_ROUTES };
